<template>
  <div class="announcements-page">
    <div class="cross" v-if="screenType == '0'">
      <div class="swiper-containerFocus">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div class="slide-content">
              <div class="title">{{ item.title }}</div>
              <div class="detail" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical" v-else>
      <div class="swiper-containerFocus">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <div class="slide-content">
              <div class="title">{{ item.title }}</div>
              <div class="detail" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="left"
      :class="screenType == 1 ? 'verticalLeft' : ''"
      @click="prev"
    >
      <dsf-icon :class="leftClouldRedClass" class="icon-fanyezuobeifen8" />
    </div>
    <div
      class="right"
      :class="screenType == 1 ? 'verticalRight' : ''"
      @click="next"
    >
      <dsf-icon :class="rightClouldRedClass" class="icon-fanyezuobeifen5" />
    </div>
  </div>
</template>

<script>
export default {
  name: "announcements",
  data() {
    return {
      swiperList: [],
      screenType: 0, //屏幕类型：0为横向，1为纵向
      currentIndex: 0,
      leftClouldRedClass: "",
      rightClouldRedClass: "",
    };
  },
  created() {
    this.loadScript(() => {
      // this.$nextTick(() => {
      //   this.initSwiper();
      // });
    });
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    //图文和视频信息，页面详情
    getData() {
      var equipmentTypeValue = 1;
      if (this.screenType == 1) {
        equipmentTypeValue = 2
      }
      var params = {
        equipmentTypeValue: equipmentTypeValue, // 屏幕类型
        releaseTypeValue: 3,
      };
      this.$http.get("/teas/screen/getInformation", params).done((res) => {
        if (res.success) {
          this.swiperList = res.data;
          if (this.screenType == 0) {
            if (this.swiperList.length > 1) {
              this.rightClouldRedClass = "redClass";
            }
          } else {
            if (this.swiperList.length > 1) {
              this.rightClouldRedClass = "orangeClass";
            }
          }
          this.$nextTick(() => {
            this.initSwiper();
          });
        } else {
          dsf.layer.message(data.message, false);
        }
      });
    },
    prev() {
      if (this.currentIndex == 0) {
        return;
      }
      this.currentIndex--;
      this.mySwiper.slidePrev();
      if (this.currentIndex == 0) {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "";
          this.rightClouldRedClass = "orangeClass";
        }
      } else {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "orangeClass";
        }
      }
    },
    next() {
      if (this.currentIndex == this.swiperList.length - 1) {
        return;
      }
      this.currentIndex++;
      this.mySwiper.slideNext();
      if (this.currentIndex == this.swiperList.length - 1) {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "";
        }
      } else {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "orangeClass";
        }
      }
    },
    // 初始化swiper
    async initSwiper() {
      const _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-containerFocus", {
          on: {},
        });
      });
    },
    // 加载js
    loadScript(callback) {
      this.$http
        .importFiles([
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.css"),
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.js"),
        ])
        .then(() => {
          callback?.();
        })
        .catch(() => {
          dsf.layer.message("加载fabric文件报错", false);
          reject();
        });
    },
  },
};
</script>

<style>
</style>